import { Outlet, createFileRoute, useParams } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { MyCertificationProfileHeader } from '../../-components/CertificationProfileHeader';
import { CertificationKind } from '../../-constants';
import { useGetMyHandlingCertificationHeader } from '../../-queries';
export const Route = createFileRoute('/_individual/individual/_profile/certifications/handling-certifications/$id/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    id
  } = useParams({
    from: '/_individual/individual/_profile/certifications/handling-certifications/$id/_layout'
  });
  const {
    data
  } = useGetMyHandlingCertificationHeader(id);
  return <VStack className="gap-0">
      <MyCertificationProfileHeader certificationId={id} certificationName={data.personHandlingCertification.certificationName} certificationNumber={data.personHandlingCertification.certificationNumber} certificationStatus={data.personHandlingCertification.certificationStatus} certificationKind={CertificationKind.HANDLING} certificationHolder={{
      name: data.personHandlingCertification.certificationHolder.name,
      avatarUrl: data.personHandlingCertification.certificationHolder.avatarUrl ?? undefined
    }} />
      <Outlet />
    </VStack>;
}